import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { ProjectAreaQueries } from '../useProjectAreaQueries';

const ProjectDetailsPage = lazyWithSuspense(() => import('./ProjectDetailsPage'));

export default makePage<any, [], ProjectAreaQueries>({
  WrappedPage: ProjectDetailsPage,
  inheritParent: true,
});
